import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import FieldDailiesToHTMLFilters from "./fieldDailiesToHTMLFilters";
import LoadingIndicator from "../../../common/loadingIndicator";

/**
 * Dailies Component
 * @returns {JSX.Element}
 * @constructor
 */
const FieldDailiesToHTML = () => {
    const [filters, setFilters] = useState({
        start_date: null,
        end_date: null,
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="Field Dailies To HTML" parent="DrillSite Settings"/>
            <FieldDailiesToHTMLFilters
                filters={filters}
                setFilters={setFilters}
            />
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default FieldDailiesToHTML;
